<a [routerLink]="'../' + relatedDoc.uniqueNumber" (click)="onClick()">
  <h3>{{ relatedDoc.title }}</h3>
  <legend>
    <span *ngIf="!relatedDoc.countryCode">{{('uishared.regions.' + relatedDoc.regionCode) | transloco}} - </span>
    <span *ngIf="relatedDoc.countryCode">{{('uishared.CountryNames.' + relatedDoc.countryCode) | transloco}} - </span>
    {{ ('uishared.groupedDocTypes.'+relatedDoc.documentType.name) | transloco }}  -
    {{ relatedDoc.publicationDate }}
  </legend>
</a>
